import React from 'react';
import { GridView } from '../../../../common/components/GridView';
import { FlexRow } from '../../../../common/components/v2';
import { Resource } from '../../../../common/constants/resource';
import { IDataGridColumn } from '../../../../common/interfaces/IDataGridColumn';
import { MVRDriverRecord, MVRViolations } from '../../../tasks/types/mvr';
import styles from '../../styles.module.scss';
import { dateToString } from '../../utilities/formattingUtilities';
import { TaskDetailsItem } from '../components/TaskDetailsItem';

const formatData = (violations: MVRViolations[]) => {
  const formattedTableData = violations.map(violation => {
    return {
      violationClass: violation.violationClass,
      suspensionDate: dateToString(violation.suspensionDate),
      standardViolationCode: violation.standardViolationCode,
      stateViolationCode: violation.stateViolationCode,
      description: violation.description,
      reinstatementDate: violation.reinstatementDate,
      points: violation.points === null ? Resource.NA : violation.points,
      providerCode: violation.providerCode
        ? violation.providerCode
        : Resource.NA,
      violationCategory: violation.violationCategory
        ? violation.violationCategory
        : Resource.NA,
      disposition: violation.disposition ? violation.disposition : Resource.NA,
    };
  });
  return formattedTableData;
};

export const RenderMVRDriverRecordSection = (driverRecord: MVRDriverRecord) => {
  if (
    driverRecord.violationStatus &&
    driverRecord.violationStatus.toUpperCase() === Resource.MVR_STATUS_CLEAR
  ) {
    return (
      <>
        <FlexRow className={styles.TaskSubtitle}>
          {Resource.MVR_DRIVERS_RECORD_SUBTITLE}
        </FlexRow>
        <TaskDetailsItem
          leftItem={Resource.MVR_CLASSIFICATION}
          rightItem={
            driverRecord.classification
              ? driverRecord.classification
              : Resource.NORA_M_DASH
          }
        />
        <TaskDetailsItem
          leftItem={Resource.MVR_DESCRIPTION}
          rightItem={
            driverRecord.description
              ? driverRecord.description
              : Resource.NORA_M_DASH
          }
        />
      </>
    );
  }
  const violations = driverRecord.violations;
  if (!violations || violations.length === 0) {
    if (
      driverRecord.violationStatus?.toUpperCase() === Resource.MVR_STATUS_HIT
    ) {
      return <>{Resource.MVR_NO_RATABLE_VIOLATIONS}</>;
    }
    return <></>;
  }
  const formattedTableData = formatData(violations);
  const columns: IDataGridColumn[] = [
    {
      name: Resource.MVR_DRIVERS_RECORD_CLASS_KEY,
      labelCopy: Resource.MVR_DRIVERS_RECORD_CLASS,
      flexBasis: '7%',
    },
    {
      name: Resource.MVR_DRIVERS_RECORD_VS_DATE_KEY,
      labelCopy: Resource.MVR_DRIVERS_RECORD_VS_DATE,
      flexBasis: '10%',
    },
    {
      name: Resource.MVR_DRIVERS_RECORD_REINSTATEMENT_KEY,
      labelCopy: Resource.MVR_DRIVERS_RECORD_REINSTATEMENT,
      flexBasis: '11%',
    },
    {
      name: Resource.MVR_DRIVERS_RECORD_DESCRIPTION_KEY,
      labelCopy: Resource.MVR_DRIVERS_RECORD_DESCRIPTION,
      flexBasis: '25%',
    },
    {
      name: Resource.MVR_DRIVERS_RECORD_VCODE_KEY,
      labelCopy: Resource.MVR_DRIVERS_RECORD_VCODE,
      flexBasis: '9%',
    },
    {
      name: Resource.MVR_DRIVERS_RECORD_STATE_VCODE_KEY,
      labelCopy: Resource.MVR_DRIVERS_RECORD_STATE_VCODE,
      flexBasis: '9%',
    },
    {
      name: Resource.MVR_DRIVERS_RECORD_POINTS_KEY,
      labelCopy: Resource.MVR_DRIVERS_RECORD_POINTS,
      flexBasis: '6.5%',
    },
    {
      name: Resource.MVR_EVC_KEY,
      labelCopy: Resource.MVR_EVC,
      flexBasis: '10%',
    },
    {
      name: Resource.MVR_VIOLATION_CATEGORY_KEY,
      labelCopy: Resource.MVR_VIOLATION_CATEGORY,
      flexBasis: '12.5%',
    },
    {
      name: Resource.MVR_VIOLATION_DISPOSITION_KEY,
      labelCopy: Resource.MVR_VIOLATION_DISPOSITION,
      flexBasis: '9%',
    },
  ];

  return (
    <>
      <FlexRow className={styles.TaskSubtitle}>
        {Resource.MVR_DRIVERS_RECORD_SUBTITLE}
      </FlexRow>
      <GridView rows={formattedTableData} columns={columns} />
    </>
  );
};
